import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';

@Component({
  selector: 'kt-payment-info',
  templateUrl: './payment-info.popup.html',
  styleUrls: ['./payment-info.popup.scss']
})
export class PaymentInfoPopup implements OnInit {
  url: SafeResourceUrl;

  constructor(@Inject(MAT_DIALOG_DATA) public data: string,
              public _sanitizer: DomSanitizer) {
  }

  ngOnInit() {
    switch (this.data) {
      case '1':
        this.url = this._sanitizer.bypassSecurityTrustResourceUrl('https://view.officeapps.live.com/op/embed.aspx?src=https://b1development.s3.eu-central-1.amazonaws.com/icibotV2/default/teslimat_ve_iade.docx');
        break;
      case '2':
        this.url = this._sanitizer.bypassSecurityTrustResourceUrl('https://view.officeapps.live.com/op/embed.aspx?src=https://b1development.s3.eu-central-1.amazonaws.com/icibotV2/default/mesafeli_satis_sozlesmesi.docx');
        break;
        case '3':
        this.url = this._sanitizer.bypassSecurityTrustResourceUrl('https://view.officeapps.live.com/op/embed.aspx?src=https://b1development.s3.eu-central-1.amazonaws.com/icibotV2/default/gizlilik_sozlesmesi.docx');
        break;
    }
  }
}
